import { COLORS } from '@constants/colors';

import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = (isBrandingModeEnabled = false) => {
  const { breakpoints } = useTheme();

  return {
    icon: {
      color: '#FFB800',
    },
    brandingModeIcon: {
      color: isBrandingModeEnabled ? COLORS.MYTAVERSE_BLUE : COLORS.WHITE,
      transition: 'color 0.2s ease',
    },
    container: {
      width: 360,
      minHeight: 200,
      padding: '20px',

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: 'calc(100vh - 106px)',
        maxHeight: 'calc(100dvh - 106px)',
      },
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
    },
    title: {
      color: COLORS.WHITE,
      fontSize: '18px',
      fontWeight: 600,
    },
    closeButton: {
      color: COLORS.WHITE,
      padding: '4px',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
    },
    tools: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: '12px',
      '& svg': {
        width: 28,
        height: 28,
        color: COLORS.WHITE,
      },
    },
  };
};
